import { ExpertAnketaSubquestionsProgression } from './ExpertAnketaSubquestionsProgression';

export default ExpertAnketaSubquestionsProgression;